import { InternalAxiosRequestConfig } from 'axios';

import { HEADER_MISSING, REQUIRED_HEADERS } from 'services/api/ApiClientService/constants';
import { getLanguage } from 'services/api/ApiClientService/helpers/languageManagement';
import { OnFulfilledRequestPropsType } from 'services/api/ApiClientService/types';

import { getPathname } from 'helpers/utils';

type RequestHandler = (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig;

const getMissingHeaders = (headers: Record<string, any>): string[] => {
    return REQUIRED_HEADERS.filter((header: string) => !Boolean(headers?.[header]));
};

// Intercepts a fulfilled request and attaches additional headers.
const onFulfilledRequest = ({
    errorHandler,
    authTokenKey,
    getAuthToken,
    headerTokenKey,
}: OnFulfilledRequestPropsType): RequestHandler => {
    return (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
        const language = getLanguage();

        let token: string | null = window?.localStorage?.getItem?.(String(authTokenKey));

        if (getAuthToken) token = getAuthToken();

        if (config.headers) {
            if (token) config.headers[headerTokenKey] = token;
            if (language) config.headers.language = language;

            // AQA needs
            config.headers.screenId = getPathname().replace('/', '');

            const missingHeaders = getMissingHeaders(config.headers);

            if (missingHeaders.length > 0) {
                const headersMissingErrors = new Error(`${HEADER_MISSING}: ${missingHeaders.join(', ')}`);

                errorHandler(headersMissingErrors, {
                    ...config,
                });

                throw headersMissingErrors;
            }
        }

        return config as InternalAxiosRequestConfig;
    };
};

export default onFulfilledRequest;
